"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-top: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: ", " !important;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  &:not(:last-child) {\n    margin-bottom: ", ";\n  }\n  &:not(:first-child) {\n    margin-top: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormItem = void 0;

var react_1 = __importDefault(require("react"));

var Typography_1 = require("./Typography");

var styledTypes_1 = require("./styledTypes");

function FormItem(_ref) {
  var children = _ref.children,
      label = _ref.label,
      extra = _ref.extra;
  return react_1["default"].createElement(Container, null, react_1["default"].createElement(LabelContainer, null, label), children, extra ? react_1["default"].createElement(ExtraContainer, {
    children: extra
  }) : null);
}

exports.FormItem = FormItem;
var Container = styledTypes_1.styled.label(_templateObject(), function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@size-s'];
});
var LabelContainer = (0, styledTypes_1.styled)(Typography_1.Body)(_templateObject2(), function (props) {
  return props.theme['@size-xs'];
});
var ExtraContainer = (0, styledTypes_1.styled)(Typography_1.Body)(_templateObject3(), function (props) {
  return props.theme['@text-color-secondary'];
}, function (props) {
  return props.theme['@size-xxs'];
});